import React, { useEffect } from "react";
import { useParams } from "react-router";
import EditableTask from "@/components/tasks/editing/EditableTask";
import { Project } from "@/api/types";
import { apiClient } from "@/api";
import SimplePage from "@/components/structure/SimplePage";

export default function CreateTask() {
  const { projectId } = useParams<{ projectId: string }>();

  // fetch info about the project from the API
  const [project, setProject] = React.useState<Project | null>(null);

  useEffect(() => {
    async function fetchProject() {
      try {
        const response = await apiClient.get<Project>(`/projects/${projectId}/`);
        setProject(response);
      }
      catch (error) {
        console.error("Failed to fetch project:", error);
      }
    }
    if (projectId) {
      fetchProject();
    }
  }, [projectId]);

  return (
    <SimplePage title="Create New Task">
        { /* Show the project name and a link to return to it */ }
        { project && (
          <div className="mb-8">
            <h2 className="text-lg font-semibold text-gray-600 mb-4">
              Creating in Project "{project ? project.name : "Loading..."}"
              
            </h2>

            <div>
              <a href={`/projects/${projectId}/edit`} className="text-blue-600 hover:underline ml-2">
              ← Return to Project
              </a>
            </div>
          </div>
        )}

        { /* EditableTask component to create a new task */ }
        <EditableTask
          project={project}
        />
    </SimplePage>
  );
}
